export function setAllLevelSettings(settings) {
    return { 
        type: 'LEVEL_SETTINGS_SET_ALL',
        payload: settings
    };
}

export function setLevelSettings(settings) {
    return { 
        type: 'LEVEL_SETTINGS_SET',
        payload: settings
    };
}

export function setLevelView(view) {
    return { 
        type: 'LEVEL_SETTINGS_SET_VIEW',
        payload: view
    };
}